/* ===== CASA · backend integration (M4): session + auth + support tickets ===== */
(function(){
  function api(path, opts){
    opts = opts || {};
    return fetch('/api' + path, {
      method: opts.method || 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function(r){ return r.json().catch(function(){ return null; }).then(function(j){ return { status: r.status, json: j }; }); })
      .catch(function(e){ return { status: 0, json: { error: String(e) } }; });
  }
  function toast(m){ try { if (typeof window.showToast === 'function') return window.showToast(m); } catch(e){} console.log('[casa]', m); }
  function closeAccount(){ try { if (typeof closeModal === 'function') closeModal('account'); } catch(e){} }

  window.casaUser = null;
  function updateAccountUI(){
    try {
      var t = document.getElementById('account-title'), s = document.getElementById('account-sub');
      if (window.casaUser){ if (t) t.textContent = 'Welcome back'; if (s) s.textContent = 'Signed in as ' + window.casaUser.email; }
      else { if (t) t.textContent = 'Welcome'; if (s) s.textContent = 'Sign in or create your account'; }
    } catch(e){}
  }
  function refreshUser(){ return api('/auth/me').then(function(r){ window.casaUser = (r.json && r.json.user) || null; updateAccountUI(); return window.casaUser; }); }

  // ---- Forgot password -------------------------------------------------
  // api/auth/forgot.js and api/auth/reset.js were both fully built — single-use
  // token, 60-minute expiry, only the SHA-256 hash stored, every session force
  // logged out on completion. Nothing in the front end ever called either one:
  // "Forgot your password?" was a bare <a> with no href and no handler, so a
  // customer who forgot their password had no route back into their account.
  function wireForgot(){
    var link = document.getElementById('casa-forgot-link');
    if (!link || link.__wired) return;
    link.__wired = true;
    var box = document.getElementById('casa-forgot-box');
    var input = document.getElementById('casa-forgot-email');
    var btn = document.getElementById('casa-forgot-send');
    var msg = document.getElementById('casa-forgot-msg');

    link.addEventListener('click', function(){
      box.style.display = box.style.display === 'none' ? 'block' : 'none';
      if (box.style.display === 'block'){
        // Pre-fill from the sign-in field — they have almost always typed it already.
        var em = document.querySelector('#tab-signin input[type=email]');
        if (em && em.value && !input.value) input.value = em.value;
        input.focus();
      }
    });

    btn.addEventListener('click', function(){
      var email = (input.value || '').trim();
      msg.style.color = 'var(--muted)';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
        msg.style.color = '#b3261e';
        msg.textContent = 'Please enter a valid email address.';
        return;
      }
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Sending…';
      api('/auth/forgot', { method:'POST', body:{ email: email } }).then(function(r){
        btn.disabled = false; btn.textContent = label;
        if (r.status === 200){
          // forgot.js always returns 200 so it never reveals whether an account
          // exists. The copy has to match that guarantee — saying "sent!" only
          // when the address is real would leak exactly what the 200 protects.
          msg.textContent = 'If an account exists for ' + email + ', a reset link is on its way. It is valid for one hour.';
          input.value = '';
        } else {
          msg.style.color = '#b3261e';
          msg.textContent = (r.json && r.json.error) || 'Something went wrong. Please email info@casaconsignment.com.';
        }
      }).catch(function(){
        btn.disabled = false; btn.textContent = label;
        msg.style.color = '#b3261e';
        msg.textContent = 'Something went wrong. Please email info@casaconsignment.com.';
      });
    });
  }

  // Sign out. api/auth/logout.js has existed and worked the whole time, but
  // nothing in the front end ever called it — both "Sign Out" controls in the
  // dashboard were alert() placeholders, so a signed-in customer had no way to
  // end their session. On a shared or borrowed device that is a real exposure,
  // not a cosmetic gap.
  window.casaLogout = function(){
    return api('/auth/logout', { method:'POST' })
      .then(function(){
        window.casaUser = null;
        updateAccountUI();
        toast('Signed out');
        // Leave any account-only view; the dashboard renders per-user data.
        try { if (typeof switchView === 'function') switchView('home'); } catch(e){}
      })
      .catch(function(){ toast('Could not sign out. Please try again.'); });
  };

  function wireAuth(){
    var signin = document.querySelector('#tab-signin form.auth-form');
    if (signin) signin.onsubmit = function(e){
      e.preventDefault();
      var em = signin.querySelector('input[type=email]'), pw = signin.querySelector('input[type=password]');
      api('/auth/login', { method:'POST', body:{ email: em && em.value, password: pw && pw.value } }).then(function(r){
        if (r.status === 200 && r.json && r.json.user){
          window.casaUser = r.json.user; updateAccountUI(); closeAccount();
          if (typeof window.casaWelcome === 'function') window.casaWelcome(r.json.user, false);
          else toast('Signed in');
        }
        else toast((r.json && r.json.error) || 'Sign in failed');
      });
    };
    var reg = document.querySelector('#tab-register form.auth-form');
    if (reg) reg.onsubmit = function(e){
      e.preventDefault();
      var names = reg.querySelectorAll('input[type=text]'), em = reg.querySelector('input[type=email]'), pw = reg.querySelector('input[type=password]');
      var name = (((names[0]&&names[0].value)||'') + ' ' + ((names[1]&&names[1].value)||'')).trim();
      var sal = reg.querySelector('select[name=salutation]');
      api('/auth/register', { method:'POST', body:{ email: em && em.value, password: pw && pw.value, name: name, salutation: sal && sal.value } }).then(function(r){
        if (r.status === 200 && r.json && r.json.user){
          window.casaUser = r.json.user; updateAccountUI(); closeAccount();
          // First sign-in is a welcome, not a "welcome back".
          if (typeof window.casaWelcome === 'function') window.casaWelcome(r.json.user, true);
          else toast('Account created');
        }
        else toast((r.json && r.json.error) || 'Could not create account');
      });
    };
    var cons = document.querySelector('#tab-consignor form.auth-form');
    if (cons) cons.onsubmit = function(e){
      e.preventDefault();
      var names = cons.querySelectorAll('input[type=text]'), em = cons.querySelector('input[type=email]'), pw = cons.querySelector('input[type=password]');
      var name = (((names[0]&&names[0].value)||'') + ' ' + ((names[1]&&names[1].value)||'')).trim();
      // Everything else on the form. Until 23 Sep 2026 only name, email and password were
      // sent, so phone, payout method, referral, the agreement consent and the opt-in were
      // required and then discarded. They now reach Casa as a Consignor Signup: a Shopify
      // customer + draft order, and an email to the support inbox (api/intake.js).
      var sels = cons.querySelectorAll('select'), boxes = cons.querySelectorAll('input[type=checkbox]');
      var ph = cons.querySelector('input[type=tel]');
      var signup = {
        name: name,
        email: em && em.value,
        phone: ph && ph.value,
        'Preferred payout method': sels[0] && sels[0].value,
        'How did you hear about us': sels[1] && sels[1].value,
        'Agreed to Consignor Agreement, Commission Tiers and Privacy Policy': (boxes[0] && boxes[0].checked) ? 'Yes, ' + new Date().toISOString() : 'No',
        'Consignor news and payout updates': (boxes[1] && boxes[1].checked) ? 'Opted in' : 'Not opted in',
        'Confirmed rightful owner and authentic items': (boxes[2] && boxes[2].checked) ? 'Yes' : 'No'
      };
      api('/auth/register', { method:'POST', body:{ email: em && em.value, password: pw && pw.value, name: name } }).then(function(r){
        if (r.status === 200 && r.json && r.json.user){
          window.casaUser = r.json.user;
          // The account exists either way; a failed filing is reported to the health
          // alerts by casaIntakeLanded rather than shown to the new consignor.
          try { window.casaIntakeLanded && window.casaIntakeLanded('consignor_signup', signup); } catch (x) {}
          var ok = document.getElementById('consignor-success'); if (ok) ok.style.display='block'; cons.style.display='none';
        }
        else if (r.status === 409) toast('Account exists — please sign in');
        else toast((r.json && r.json.error) || 'Could not create seller account');
      });
    };
  }

  // Ticket attachments — same compress → upload-to-Blob pipeline as Consign a
  // Piece / Sell to Casa (casaCompressPhoto / api/consignment-photo are already
  // generic, keyed only by ref+slot). Kept in their own ref+state, same reason
  // window.casaSellPhotos is kept separate from window.casaConsignPhotos: so a
  // ticket in progress can't cross-contaminate whichever of those two flows a
  // visitor also has open.
  window.casaTicketPhotos = [];
  // Uploads still running. openContactTicket() reads this to tell a half-finished
  // draft from an untouched form, before deciding whether it may reset either.
  window.casaTicketPhotosPending = 0;
  var casaTicketPhotoRef = null;
  // Bumped by every reset. An upload that started under an earlier generation
  // belongs to a ticket that no longer exists, so its result is dropped instead of
  // being pushed into whichever ticket is on screen when it lands.
  var casaTicketPhotoGen = 0;
  function casaTicketPhotoSubmissionRef() {
    if (!casaTicketPhotoRef) casaTicketPhotoRef = 'tk' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    return casaTicketPhotoRef;
  }
  // `ref` is passed in, not resolved here: it has to be the ref of the ticket the
  // file was chosen on, not whatever ref exists by the time compression finishes.
  function casaUploadTicketPhoto(blob, ref) {
    return fetch('/api/consignment-photo?ref=' + encodeURIComponent(ref) + '&slot=extra', {
      method: 'POST', headers: { 'Content-Type': blob.type || 'image/jpeg' }, body: blob
    }).then(function(r){ return r.json().catch(function(){ return {}; }); })
      .then(function(j){ return (j && j.ok && j.url) ? j.url : null; })
      .catch(function(){ return null; });
  }
  window.casaResetTicketPhotos = function() {
    window.casaTicketPhotos = [];
    window.casaTicketPhotosPending = 0;
    casaTicketPhotoRef = null;
    casaTicketPhotoGen++;
    var thumbs = document.getElementById('ticket-photo-thumbs');
    if (thumbs) thumbs.innerHTML = '';
  };
  (function wireTicketPhotoInput(){
    var input = document.getElementById('ticket-photo-input');
    if (!input || input.__wired) return;
    input.__wired = true;
    input.addEventListener('change', function(e){
      var thumbs = document.getElementById('ticket-photo-thumbs');
      var room = 5 - window.casaTicketPhotos.length;
      var files = Array.prototype.slice.call(e.target.files || []).slice(0, Math.max(0, room));
      // Mint the ref once, here, and remember which ticket generation these files
      // belong to. Both used to be resolved after compression finished, which is
      // what let a reset in between move a photo onto the next ticket.
      var ref = files.length ? casaTicketPhotoSubmissionRef() : null;
      var gen = casaTicketPhotoGen;
      files.forEach(function(file){
        if (!file.type || file.type.indexOf('image/') !== 0) return;
        var thumb = document.createElement('div');
        thumb.className = 'upload-thumb uploading';
        if (thumbs) thumbs.appendChild(thumb);
        var r = new FileReader();
        r.onload = function(ev){ thumb.innerHTML = '<img src="' + ev.target.result + '">'; };
        r.readAsDataURL(file);
        window.casaTicketPhotosPending++;
        casaCompressPhoto(file).then(function(blob){
          return (gen === casaTicketPhotoGen) ? casaUploadTicketPhoto(blob, ref) : null;
        }).then(function(url){
          // Reset while this was in flight: the thumbs are already gone and the
          // pending count already zeroed, so there is nothing to update and this
          // URL must not join the new ticket's photos.
          if (gen !== casaTicketPhotoGen) return;
          window.casaTicketPhotosPending--;
          thumb.classList.remove('uploading');
          if (url) { window.casaTicketPhotos.push(url); thumb.classList.add('uploaded'); }
          else { thumb.classList.add('upload-failed'); try { window.casaSignal && window.casaSignal('photo_upload_failed', 'ticket'); } catch (e) {} }
        });
      });
      input.value = '';
    });
  })();

  // Support tickets → real ticket + email to info@casaconsignment.com
  window.submitContactTicket = function(e){
    if (e && e.preventDefault) e.preventDefault();
    var cat = (document.getElementById('contact-cat')||{}).value || '';
    var subject = ((document.getElementById('contact-subject')||{}).value || 'Support request').trim();
    var message = ((document.getElementById('contact-message')||{}).value || '').trim();
    var order = ((document.getElementById('contact-order')||{}).value || '').trim();
    var name = ((document.getElementById('contact-name')||{}).value || '').trim();
    // The typed address wins over the session's: a signed-in member may be
    // writing about an order placed under a different one, and the field is
    // prefilled with their account address anyway.
    var email = (((document.getElementById('contact-email')||{}).value || '').trim() ||
                 (window.casaUser && window.casaUser.email) || '').toLowerCase();

    // Mirrors the server's own caps (api/tickets.js slices subject to 200 and
    // body to 4000). The earlier mock handler validated; the real one that
    // replaced it did not, so an over-long message was silently truncated.
    if (subject.length < 3) { toast('Please add a subject (at least 3 characters).'); return false; }
    if (message.length < 5) { toast('Please tell us a little more — at least 5 characters.'); return false; }
    if (subject.length > 200) { toast('Subject is too long (200 characters maximum).'); return false; }
    if (message.length > 4000) { toast('Message is too long (4000 characters maximum).'); return false; }
    // Without an address there is no way to answer. api/tickets.js accepts a
    // blank one, which is how guest tickets became unanswerable in the first place.
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast('Please enter a valid email address so we can reply.');
      var _em = document.getElementById('contact-email'); if (_em) _em.focus();
      return false;
    }

    // The order id was collected and then thrown away. Carry it in the body,
    // which is what a specialist actually reads.
    var body = message;
    if (order) body = 'Order reference: ' + order + '\n\n' + message;
    if (name) body = 'From: ' + name + '\n' + body;

    api('/tickets', { method:'POST', body:{ subject: (cat ? cat + ' — ' : '') + subject, body: body, email: email, photos: window.casaTicketPhotos.slice() } }).then(function(r){
      if (r.status === 200 && r.json && r.json.ticket){
        var idEl = document.getElementById('contact-ticket-id'); if (idEl) idEl.textContent = '#' + r.json.ticket.id;
        var succ = document.getElementById('contact-success'); if (succ) succ.style.display = 'block';
        if (typeof window.casaResetTicketPhotos === 'function') window.casaResetTicketPhotos();
        // Hide the FORM, not #contact-body. #contact-success is a CHILD of
        // #contact-body, so hiding the parent hid the confirmation that had just
        // been shown one line above: the ticket was created and emailed, and the
        // customer watched the modal go blank. openContactTicket() only ever
        // restored #contact-form, so the contact form then stayed dead for the
        // rest of the session. Fixed 6 Aug 2026.
        var frm = document.getElementById('contact-form'); if (frm) frm.style.display = 'none';
      } else {
        try { window.casaSignal && window.casaSignal('form_submit_failed', 'ticket: status ' + r.status); } catch (x) {}
        toast((r.json && r.json.error) || 'Could not submit ticket');
      }
    });
    return false;
  };

  // ---- catalog from DB (products API is the source of truth) ----
  function money(n){ return (n==null||n==='')?'Price on request':('$'+Number(n).toLocaleString('en-US')); }
  function toArrival(p){
    return { sku:p.sku, brand:p.brand||'', name:p.name||p.sku, price: money(p.price),
      retail:(p.retail!=null&&p.retail!=='')?money(p.retail):'', cond:p.condition||'', badge:'',
      img:(p.gallery&&p.gallery[0])||'', gallery:Array.isArray(p.gallery)?p.gallery:[],
      size:p.size||'—', color:p.color||'—', hardware:p.hardware||'—', year:p.year||'—',
      // Was a hard-coded 'Handbags', which overwrote the curated category ~400ms
      // after load and misfiled every non-bag. window.CASA_CATEGORY is published
      // by the FINAL INVENTORY module and only ever holds the four real filter
      // buckets, so this can never introduce a category the shop can't render.
      includes:p.includes||'', category:(window.CASA_CATEGORY && window.CASA_CATEGORY[p.sku]) || 'Handbags',
      authStatus:p.auth_status||'pending',
      legitCaseId:p.legit_case_id||null, seq:1, date:'2026-07-01',
      // Shopify variant this SKU maps to — real checkout needs it. Sourced from
      // the DB (set by /api/shopify-sync) so it can't drift from a hardcoded list.
      shopifyVariantId: p.shopify_variant_id || null,
      shopifyPrice: (p.shopify_price==null||p.shopify_price==='')?null:Number(p.shopify_price),
      shopifySaleable: p.shopify_saleable === false ? false : (p.shopify_saleable === true ? true : null),
      priceNum: (p.price==null||p.price==='')?null:Number(p.price) };
  }
  function rerenderCatalog(){
    try{ if(typeof renderShopGrid==='function') renderShopGrid(); }catch(e){}
    // Home-arrivals + New In: shared with the final-inventory module's r()
    // via window.casaRefreshHomeAndNewIn() — one function owns both writes,
    // so there is no second copy of this logic that could drift out of sync.
    if (typeof window.casaRefreshHomeAndNewIn === 'function') window.casaRefreshHomeAndNewIn();
    try{ if(typeof renderDesignerCards==='function') renderDesignerCards(); }catch(e){}
  }
  function hydrateCatalog(retried){
    return api('/products').then(function(r){
      // api() never rejects; a blocked or failed call arrives here as status 0 / no list.
      // 24 Sep 2026: phones on in-app browsers dropped this request (status 0) and were
      // left on the built-in list. One retry after 2 s; only a second failure is reported.
      if(!(r.json && Array.isArray(r.json.products)) && retried !== true){
        return new Promise(function(res){ setTimeout(res, 2000); }).then(function(){ return hydrateCatalog(true); });
      }
      if(!(r.json && Array.isArray(r.json.products))){ try{ window.casaSignal && window.casaSignal('catalog_load_failed', 'status '+r.status+' after retry'); }catch(e){} }
      if(!(r.json && Array.isArray(r.json.products)) || typeof arrivals==='undefined') return;
      var mapped=r.json.products.map(toArrival);
      if(!mapped.length) return;
      arrivals.length=0; Array.prototype.push.apply(arrivals, mapped);
      rerenderCatalog();
    }).catch(function(e){ console.warn('[casa] hydrateCatalog', e); })
      // Finished, loaded or not: casaAddToCart() waits on this instead of refusing early.
      .then(function(){ window.__casaCatalogLoaded = true; });
  }

  function wireCommerce(){
    // ---------------------------------------------------------------------
    // REAL CHECKOUT → Shopify hosted checkout.
    //
    // Shopify collects the card, the shipping address and tax; the order lands
    // in Shopify admin (which is where the business is run from); and the
    // `orders/paid` webhook marks the SKU sold here so it leaves the grid.
    //
    // This deliberately REPLACES the earlier /api/checkout path, which completed
    // a Shopify draft order with payment_pending=false — i.e. marked an order
    // paid while collecting nothing. /api/checkout is now staff-only.
    //
    // Variant IDs come from the DB (products.shopify_variant_id, populated by
    // /api/shopify-sync) and fall back to the legacy hardcoded map.
    // ---------------------------------------------------------------------
    // Resolve a SKU to a purchasable Shopify variant.
    //
    // FAIL-SAFE PRICE GUARD: if Shopify would charge a different amount than the
    // storefront advertises, this returns null so the item cannot be bought.
    // Charging more than the displayed price is a consumer-protection problem and
    // an instant chargeback; refusing the sale is the safer failure. Reconcile the
    // price in Shopify (or run /api/shopify-sync with syncPrice) to re-enable it.
    function purchaseInfo(sku){
      var arr=[], a=null;
      try {
        arr = (typeof arrivals!=='undefined' && Array.isArray(arrivals)) ? arrivals : [];
        a = arr.find(function(x){ return x && x.sku===sku; }) || null;
      } catch(e){}

      var vid=null;
      if (a && a.shopifyVariantId){
        var v=String(a.shopifyVariantId);
        vid = v.indexOf('gid://')===0 ? v : 'gid://shopify/ProductVariant/'+v;
      } else {
        var legacy=(window.CASA_VARIANT_MAP||{})[sku];
        // The legacy hardcoded map has stale prices, so only trust it for the
        // variant id when the DB hasn't supplied one yet.
        if (legacy && legacy.vid) vid = legacy.vid;
      }
      if (!vid) return { vid:null, reason:'not-in-shopify' };
      if (a && a.shopifySaleable === false) return { vid:null, reason:'not-saleable' };
      if (a && a.shopifyPrice != null && a.priceNum != null
          && Math.abs(Number(a.shopifyPrice) - Number(a.priceNum)) > 0.005){
        console.warn('[casa] price mismatch blocked', sku, 'shown', a.priceNum, 'shopify', a.shopifyPrice);
        return { vid:null, reason:'price-mismatch' };
      }
      return { vid:vid, reason:null };
    }
    function variantFor(sku){ return purchaseInfo(sku).vid; }
    window.casaVariantFor = variantFor;
    window.casaPurchaseInfo = purchaseInfo;

    window.casaShopifyCheckout = async function(btn){
      var cart=[]; try{ cart=JSON.parse(localStorage.getItem('casa_cart')||'[]'); }catch(e){}
      if(!Array.isArray(cart)||!cart.length){ toast('Your bag is empty.'); return; }

      var lines=[], missing=[];
      for(var i=0;i<cart.length;i++){
        var vid=variantFor(cart[i].sku);
        if(vid) lines.push({ vid:vid, qty:cart[i].qty||1 }); else missing.push(cart[i].sku);
      }
      if(!lines.length){
        toast(missing.length ? "These pieces aren't available to purchase online yet — please contact us."
                             : 'Your bag is empty.');
        return;
      }
      if(missing.length) toast(missing.join(', ')+" can't be purchased online yet — continuing with the rest.");

      var restore=null;
      if(btn&&btn.tagName){ restore=btn.textContent; btn.textContent='Redirecting to secure checkout…'; btn.style.pointerEvents='none'; btn.style.opacity='0.7'; }

      var SHOP=(window.CASA_CONFIG&&window.CASA_CONFIG.SHOPIFY_DOMAIN)||'casa-consignment.myshopify.com';
      var TOKEN=(window.CASA_CONFIG&&window.CASA_CONFIG.SHOPIFY_STOREFRONT_TOKEN)||'';

      // CONCIERGE CLUB WELCOME DISCOUNT — 5% off the first order after joining
      // Gold or Elite. The browser does NOT decide this: window.casaMembership
      // is settable from devtools, so eligibility is asked of the server, which
      // reads the membership row and the order history. Shopify then re-checks
      // the code against a Gold+Elite customer segment with one-use-per-customer,
      // so this request is a convenience, not the enforcement.
      //
      // Failure here must never cost the sale. Any error, timeout or non-answer
      // falls through to an undiscounted checkout — the member can be credited
      // afterwards, but a shopper who cannot buy at all is gone.
      var discountCodes=[];
      try{
        var dres=await api('/member-discount');
        var dj=dres&&dres.json;
        if(dj&&dj.eligible&&dj.code) discountCodes.push(String(dj.code));
      }catch(e){ console.warn('[casa] member-discount lookup skipped', e); }

      // Codes are interpolated into a GraphQL string literal, so anything that
      // could close the quote has to go. Shopify codes are alphanumeric with
      // dashes/underscores; refuse the rest rather than ship a broken mutation.
      discountCodes=discountCodes.filter(function(c){ return /^[A-Za-z0-9_-]{1,64}$/.test(c); });

      var discountArg=discountCodes.length
        ? ',discountCodes:['+discountCodes.map(function(c){ return '"'+c+'"'; }).join(',')+']'
        : '';
      var q='mutation{ cartCreate(input:{lines:['+lines.map(function(l){
        return '{quantity:'+l.qty+',merchandiseId:"'+l.vid+'"}'; }).join(',')+
        ']'+discountArg+'}){ cart{ checkoutUrl discountCodes{ code applicable } } userErrors{ message } } }';
      try{
        var res=await fetch('https://'+SHOP+'/api/2024-10/graphql.json',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':TOKEN},
          body:JSON.stringify({query:q})
        });
        var j=await res.json();
        var cc=j&&j.data&&j.data.cartCreate;
        var url=cc&&cc.cart&&cc.cart.checkoutUrl;

        // Shopify accepts an unknown or non-applicable code SILENTLY — the cart
        // is created, checkoutUrl is valid, and the buyer simply pays full price.
        // That is the failure mode this warning exists to catch: if CLUB5 has not
        // been created in Shopify admin, or its customer-segment restriction
        // excludes this buyer, everything looks fine from the outside.
        if(discountCodes.length){
          var applied=(cc&&cc.cart&&cc.cart.discountCodes)||[];
          var ok=applied.some(function(d){ return d&&d.applicable; });
          if(!ok){
            console.warn('[casa] Concierge Club 5% NOT applied. The server said this '+
              'member is eligible, but Shopify rejected '+JSON.stringify(discountCodes)+
              '. Check the code exists in Shopify admin, is active, and that its '+
              'customer-segment restriction includes this customer. Shopify returned: '+
              JSON.stringify(applied));
          }
        }

        if(url){
          // GUARD: Shopify builds checkout URLs on its own *primary domain*. If that
          // is still casaconsignment.com — which now resolves to this Vercel site —
          // the customer lands on our 404 instead of Shopify's payment page, and
          // Shopify 301s any other host back to the primary, so there is no
          // client-side fix. Fail loudly rather than dumping the buyer on a 404.
          var sameHost=false;
          try{ sameHost = !window.Shopify && (new URL(url)).host === window.location.host; }catch(e){}
          if(sameHost){
            console.error('[casa] CHECKOUT MISCONFIGURED: Shopify returned a checkout URL on '+
              'this site\'s own domain ('+url.split('?')[0]+'). Set Shopify\'s primary domain to a '+
              'host that points at Shopify (e.g. shop.casaconsignment.com) so checkout resolves.');
            try{ window.casaSignal && window.casaSignal('checkout_start_failed', 'checkout URL on own host'); }catch(e){}
            toast('Checkout is temporarily unavailable — please contact us to complete your purchase.');
            if(btn&&restore!=null){ btn.textContent=restore; btn.style.pointerEvents=''; btn.style.opacity=''; }
            return;
          }
          // Shopify sends the order-confirmation email; the webhook marks it sold.
          // Clear our local bag now so a back-button return isn't stale.
          try{ localStorage.setItem('casa_cart','[]'); }catch(e){}
          // RETURNING FROM CHECKOUT (23 Sep 2026). Chrome on iPhone can bring this page
          // back as a frozen snapshot (tapping the Casa logo on Shopify's checkout):
          // button stuck on "Redirecting…", bag drawer showing items the line above
          // already cleared. The marker lives only in this page's memory, so it
          // survives a snapshot restore and never a fresh load: reloading then gives
          // exactly what every other browser already shows. Nothing else reads it.
          window.__casaLeftForCheckout = true;
          if(!window.__casaCheckoutReturnHook){
            window.__casaCheckoutReturnHook = true;
            window.addEventListener('pageshow', function(){
              if(!window.__casaLeftForCheckout) return;
              window.__casaLeftForCheckout = false;
              window.location.reload();
            });
          }
          // Reached Shopify with a real checkout (analytics; value in USD, pieces we could sell).
          var value = 0;
          try {
            var arr = (typeof arrivals !== 'undefined' && Array.isArray(arrivals)) ? arrivals : [];
            cart.forEach(function(c){
              if (missing.indexOf(c.sku) !== -1) return;
              var a = arr.find(function(x){ return x && x.sku === c.sku; });
              if (a && typeof a.priceNum === 'number') value += a.priceNum * (c.qty || 1);
            });
          } catch (e) {}
          window.casaTrack('Checkout Handoff', { items: lines.length, value: Math.round(value) });
          window.location.href=url; return;
        }
        var em=(cc&&cc.userErrors&&cc.userErrors.length&&cc.userErrors[0].message)||'';
        console.warn('[casa] cartCreate failed', j);
        try{ window.casaSignal && window.casaSignal('checkout_start_failed', 'cartCreate: '+(em || 'no checkout URL')); }catch(e){}
        toast(em || 'Sorry — checkout could not start. Please try again.');
      }catch(e){ console.warn('[casa] checkout error', e); try{ window.casaSignal && window.casaSignal('checkout_start_failed', 'network: '+(e && e.message)); }catch(x){} toast('Network error starting checkout.'); }
      if(btn&&restore!=null){ btn.textContent=restore; btn.style.pointerEvents=''; btn.style.opacity=''; }
    };
    // ⚠️ REMOVED 3 Sep 2026 — a wrapper here used to fire an extra
    // `POST /api/consignments` whenever a SIGNED-IN visitor submitted Sell to Casa,
    // on top of the /api/intake call casaSellToCasaSubmit already makes. One
    // submission produced two of everything, and the second copy was the worse one:
    //
    //   · a second staff email to info@ carrying NO photos and a reference (#4, #5)
    //     that exists nowhere in Shopify — nothing links it to the draft order
    //   · a SECOND acknowledgement to the customer quoting that different reference,
    //     after /api/intake had already acknowledged them
    //   · a `consignments` row attributed to the SESSION account, which need not be
    //     the address typed on the form. Draft order #D47 and its duplicate row #4
    //     recorded two different addresses. Same submission, two identities.
    //
    // `consignments` is a later stage of a piece's life — authenticated, listed, paid
    // out (see api/payouts.js and the PATCH actions in api/consignments.js). It is not
    // an intake table, and nothing public should write 'submitted' rows into it as a
    // side effect. The intake path alone is correct: /api/intake creates the Shopify
    // draft order with the photos and emails both sides once.
  }

  function init(){ try { wireAuth(); wireForgot(); wireCommerce(); refreshUser(); setTimeout(hydrateCatalog, 400); } catch(e){ console.warn('[casa] wiring', e); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
